const detectZoom = require('detect-zoom')
function randomWord (randomFlag, min, max) {
  let str = ''
  let range = min
  let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (var i = 0; i < range; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
module.exports = {
  getPosition: function (dom, parent) {
    var ret = {
      x: 0,
      y: 0
    }
    while (dom && dom !== parent && dom !== document.documentElement) {
      ret.x += dom.offsetLeft
      ret.y += dom.offsetTop
      dom = dom.offsetParent
    }
    return ret
  },
  reg: {
    idCard: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/,
    phone: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
    email: /^[A-Za-z\d]+([_.-][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
    guhua: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/
  },
  isEmptyObject: function (obj) {
    for (var key in obj) {
      return false
    };
    return true
  },
  detectZoom: function () {
    var zoom = detectZoom.zoom()
    var device = detectZoom.device()
    return [zoom, device]
  },
  isWide: function () {
    return Math.round(devicePixelRatio * 100) === 100 ? window.innerWidth > 1600 : true
  },
  isWorkPhone: function (phone) {
    let phones = [
      /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
      /^(\+?213|0)(5|6|7)\d{8}$/,
      /^(!?(\+?963)|0)?9\d{8}$/,
      /^(!?(\+?966)|0)?5\d{8}$/,
      /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
      /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
      /^(\+?49[ .-])?([(]{1}[0-9]{1,6}[)])?([0-9 .-/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
      /^(\+?45)?(\d{8})$/,
      /^(\+?30)?(69\d{8})$/,
      /^(\+?61|0)4\d{8}$/,
      /^(\+?44|0)7\d{9}$/,
      /^(\+?852-?)?[569]\d{3}-?\d{4}$/,
      /^(\+?91|0)?[789]\d{9}$/,
      /^(\+?64|0)2\d{7,9}$/,
      /^(\+?27|0)\d{9}$/,
      /^(\+?26)?09[567]\d{7}$/,
      /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
      /^(\+?358|0)\s?(4(0|1|2|4|5)?|50)\s?(\d\s?){4,8}\d$/,
      /^(\+?33|0)[67]\d{8}$/,
      /^(\+972|0)([23489]|5[0248]|77)[1-9]\d{6}/,
      /^(\+?36)(20|30|70)\d{7}$/,
      /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
      /^(\+?81|0)\d{1,4}[ -]?\d{1,4}[ -]?\d{4}$/,
      /^(\+?6?01){1}(([145]{1}(-|\s)?\d{7,8})|([236789]{1}(\s|-)?\d{7}))$/,
      /^(\+?47)?[49]\d{7}$/,
      /^(\+?32|0)4?\d{8}$/,
      /^(\+?47)?[49]\d{7}$/,
      /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
      /^(\+?55|0)-?[1-9]{2}-?[2-9]{1}\d{3,4}-?\d{4}$/,
      /^(\+?351)?9[1236]\d{7}$/,
      /^(\+?7|8)?9\d{9}$/,
      /^(\+3816|06)[- \d]{5,9}$/,
      /^(\+?90|0)?5\d{9}$/,
      /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
      /^(\+?0?86-?)?1[345789]\d{9}$/,
      /^(\+?886-?|0)?9\d{8}$/
    ]
    for (let i = 0; i < phones.length; i++) {
      if (phones[i].test(phone)) {
        return true
      }
    }
    return false
  },
  formatDate: function (time) {
    var date = new Date(time)
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    // var hour = date.getHours()
    // var minute = date.getMinutes()
    // var second = date.getSeconds()
    //  return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
    return year + '-' + (String(month).length > 1 ? month : '0' + month) + '-' +
      (String(day).length > 1 ? day : '0' + day)
      // + ' ' + (String(hour).length > 1 ? hour : '0' + hour) + ':' + (String(minute).length > 1 ? minute : '0' + minute) +
      //  ':' + (String(second).length > 1 ? second : '0' + second)
  },

  encodeStr: function (str, strv = '') {
    const NUM = 2
    const front = randomWord(false, 8)
    const middle = randomWord(false, 8)
    const end = randomWord(false, 8)

    let str1 = str.substring(0, NUM)
    let str2 = str.substring(NUM)

    if (strv) {
      let strv1 = strv.substring(0, NUM)
      let strv2 = strv.substring(NUM)
      return [front + str2 + middle + str1 + end, front + strv2 + middle + strv1 + end]
    }

    return front + str2 + middle + str1 + end
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js